import { render, staticRenderFns } from "./vue-clock.vue?vue&type=template&id=580b6c85&scoped=true&"
import script from "./vue-clock.vue?vue&type=script&lang=js&"
export * from "./vue-clock.vue?vue&type=script&lang=js&"
import style0 from "./vue-clock.vue?vue&type=style&index=0&id=580b6c85&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580b6c85",
  null
  
)

export default component.exports